module.exports = __webpack_public_path__ + "img/megavoice.9396108.png";